import { render, staticRenderFns } from "./monthly-pay-student-view.vue?vue&type=template&id=4a72cda1&"
import script from "./monthly-pay-student-view.vue?vue&type=script&lang=js&"
export * from "./monthly-pay-student-view.vue?vue&type=script&lang=js&"
import style0 from "./monthly-pay-student-view.vue?vue&type=style&index=0&id=4a72cda1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports